/**
 * Shared test for "can this lift be shown as a pin on the Lift Map".
 *
 * TE-2087. Both the Lift Map (which filters the pins it plots) and the Lifts
 * table (which enables or disables the Map link per row) need this answer, and
 * they must agree: if the table offered a Map link for a lift the map does not
 * plot, the deep link would open the map with nothing focused.
 *
 * A lift is plottable when both coordinates are present, numeric and within
 * the valid range (latitude -90..90, longitude -180..180). The API returns them
 * as either strings or numbers, so they are coerced before the checks. Note
 * isNaN(Number(null)) is false, hence the explicit null guard.
 *
 * The range check matters because devices do report impossible values (e.g.
 * 333.66, 182.01). Google Maps clamps such a latitude to the pole and wraps the
 * longitude, so the pin lands where there is no imagery and the map shows grey.
 */
export function hasPlottableCoords(lift) {
  if (!lift) return false;
  if (
    lift.latitude == null ||
    lift.longitude == null ||
    lift.latitude === "" ||
    lift.longitude === ""
  ) {
    return false;
  }
  const lat = Number(lift.latitude);
  const lng = Number(lift.longitude);
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 && lat <= 90 &&
    lng >= -180 && lng <= 180
  );
}
